import React, { useEffect, useState } from "react";
import PageLoader from "../app/PageLoader";
import {
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  TextareaAutosize,
  Typography,
  Card,
  CardContent,
  Autocomplete,
  Box,
  Link,
  Alert,
  Tooltip,
  Icon,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
  FormGroup,
} from "@mui/material";
import {
  PartsPortalType,
  PortalImageType,
  ShoppingPortal,
  ShoppingPortalInitialValues,
  ShoppingPortalValidationSchema,
  SocialLinkType,
} from "../../models/features/ShopifySetting/ShoppingPortal/ShoppingPortal";
import { Form, Formik, ErrorMessage, FormikProps } from "formik";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import CloseIcon from "@mui/icons-material/Close";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import KeyIcon from "@mui/icons-material/Key";
import {
  useAddShoppingPortalMutation,
  useGetShoppingPortalQuery,
  useDeletePortalImageMutation,
  useSetPortalEnableMutation,
} from "../../redux/reducer/features/Setting/Shopping Portal/ShoppingPortalSettingSlice";
import { DmsManufacturer } from "../../models/features/ShoppingPortal/DmsManufacturer";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import ReactQuill from "react-quill";
import InfoIcon from "@mui/icons-material/Info";

import "react-quill/dist/quill.snow.css";
import {
  setPartsPortalEnable,
  setPartsPortalType,
  useGetDmsManufacturersQuery,
} from "../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import PhoneInput from "react-phone-input-2";

export const ShoppingPortalPage: React.FunctionComponent = () => {
  const dispatch = useDispatch();

  const [storeAlert, setStoreAlert] = useState<string>();
  const shopifyUrl = useSelector(
    (state: AppState) => state.authReducer?.dmsSetup?.storeUrl
  );
  const dmsLocations = useSelector(
    (state: AppState) => state.authReducer?.dmsSetup?.dmsLocations
  );
  const partsPortalSetting = useSelector(
    (state: AppState) => state.shoppingPortalReducer
  );
  const { data, isLoading, refetch, isSuccess } = useGetShoppingPortalQuery();
  const [addShoppingPortalMutation, addShoppingPortalMutationResult] =
    useAddShoppingPortalMutation();
  const [enablePortalMutation, enablePortalMutationResult] =
    useSetPortalEnableMutation();
  const { data: dmsManufacturersList } = useGetDmsManufacturersQuery({
    dealerId: dmsLocations ? dmsLocations[0].dealerId.toString() ?? "" : "",
  });

  const [deleteImageMutation, deleteImageMutationResult] =
    useDeletePortalImageMutation();
  const [shoppingPortal, setShoppingPortal] = useState<any>(
    ShoppingPortalInitialValues
  );
  const [savedImages, setSavedImages] = useState<any>([]);
  const [savedLogo, setSavedLogo] = useState<any>();
  const [defaultMfgs, setDefaultMfgs] = useState<DmsManufacturer[]>([]);
  const [dmsManufacturers, setDmsManufacturers] = useState<DmsManufacturer[]>(
    []
  );
  const [showAlert, setShowAlert] = useState<any>(true);
  const formRef: React.Ref<FormikProps<ShoppingPortal>> = React.useRef(null);
  const handleOnSubmit = (values: ShoppingPortal) => {
    console.log("Submitted Data", values);
    const formData = new FormData();
    formData.append("id", values.id ?? "");
    formData.append("portalName", values.portalName);
    formData.append("primaryPhone", values.primaryPhone);
    formData.append("email", values.email);
    formData.append("about", values.about);
    formData.append("invoiceNote", values?.invoiceNote ?? "");
    formData.append("secondaryPhone", values.secondaryPhone ?? "");
    formData.append("address", values.address);
    formData.append(
      "activeCategoryFilter",
      (values.activeCategoryFilter ?? false).toString()
    );
    formData.append(
      "activeManufacturerFilter",
      (values.activeManufacturerFilter ?? false).toString()
    );
    formData.append("shippingCharge", values.shippingCharge.toString());
    formData.append("portalType", values.portalType.toString());

    formData.append(
      "storefrontAccessToken",
      values?.storefrontAccessToken?.toString()
    );
    formData.append(
      "socialLinks[0].linkType",
      SocialLinkType.Facebook.toString()
    );
    formData.append("socialLinks[0].linkUrl", values.facebookURL ?? "");
    formData.append(
      "socialLinks[1].linkType",
      SocialLinkType.Twitter.toString()
    );
    formData.append("socialLinks[1].linkUrl", values.twitterURL ?? "");
    formData.append(
      "socialLinks[2].linkType",
      SocialLinkType.Instagram.toString()
    );
    formData.append("socialLinks[2].linkUrl", values.instagramURL ?? "");
    formData.append(
      "socialLinks[3].linkType",
      SocialLinkType.LinkedIn.toString()
    );
    formData.append("socialLinks[3].linkUrl", values.linkedInURL ?? "");
    let index = 0;
    if (values.portalLogo?.name) {
      formData.append("images[0].type", PortalImageType.Logo.toString());
      formData.append("images[0].image", values.portalLogo ?? "");
      ++index;
    }

    values.bannerImages.map((item: any) => {
      formData.append(
        `images[${index}].type`,
        PortalImageType.Banner.toString()
      );
      formData.append(`images[${index}].image`, item ?? "");
      ++index;
    });
    values.hideMfgs?.map((mfg, index: number) => {
      formData.append(`hideMfgs[${index}]`, mfg);
    });
    addShoppingPortalMutation({ data: formData });
  };
  useEffect(() => {
    if (!isLoading) {
      refetch();
    }
  }, []);
  useEffect(() => {
    if (
      addShoppingPortalMutationResult.data &&
      addShoppingPortalMutationResult.isSuccess
    ) {
      if (addShoppingPortalMutationResult.data.status === 200) {
        setShoppingPortalObjectValues(addShoppingPortalMutationResult.data);
      }
    }
  }, [addShoppingPortalMutationResult]);

  useEffect(() => {
    if (data && isSuccess) {
      if (data.status === 0) {
        setShoppingPortalObjectValues(data);
      }
    }
  }, [data]);
  React.useEffect(() => {
    if (
      dmsManufacturersList?.entityList &&
      dmsManufacturersList.entityList?.length > 0
    ) {
      setDmsManufacturers(dmsManufacturersList.entityList);
    }
  }, [dmsManufacturersList]);

  const setShoppingPortalObjectValues = (data: any) => {
    let fbUrl = data.entity.socialLinks.find(
      (item: any) => item.linkType === "Facebook"
    )?.linkUrl;
    let twUrl = data.entity.socialLinks.find(
      (item: any) => item.linkType === "Twitter"
    )?.linkUrl;
    let LiUrl = data.entity.socialLinks.find(
      (item: any) => item.linkType === "LinkedIn"
    )?.linkUrl;
    let instaUrl = data.entity.socialLinks.find(
      (item: any) => item.linkType === "Instagram"
    )?.linkUrl;
    let socialLinks = {
      facebookURL: fbUrl ?? "",
      twitterURL: twUrl ?? "",
      linkedInURL: LiUrl ?? "",
      instagramURL: instaUrl ?? "",
    };
    let portalType =
      data?.entity?.portalType === "StandAlone"
        ? PartsPortalType.StandAlone
        : PartsPortalType.Embedded;
    let isPortalEnable = data?.entity?.isPortalEnabled;
    setShoppingPortal({
      ...shoppingPortal,
      ...data.entity,
      portalType: portalType,
      ...socialLinks,
      portalLogoName: data.entity?.images.some(
        (img: any) => img.type === "Logo"
      )
        ? "Exist"
        : "Not Exists",
    });
    setSavedImages(
      data.entity?.images.filter((img: any) => img.type === "Banner")
    );
    setSavedLogo(data.entity?.images.find((img: any) => img.type === "Logo"));
    if (
      data.entity?.gravitySettingsCount === 0 &&
      data.entity?.paypalSettingsCount === 0
    ) {
      setStoreAlert(
        "Payment settings do not exist or are not configured as default."
      );
    }
    dispatch(setPartsPortalType({ type: portalType }));
    dispatch(setPartsPortalEnable({ isEnabled: isPortalEnable }));
  };

  useEffect(() => {
    if (dmsManufacturers.length > 0 && defaultMfgs.length === 0) {
      handleSetDefaultMfgs();
    }
  }, [dmsManufacturers]);
  useEffect(() => {
    if (shoppingPortal?.hideMfgs) handleSetDefaultMfgs();
  }, [shoppingPortal]);
  const handleDeleteImage = (imageId: string) => {
    deleteImageMutation({ Id: imageId });
  };
  const handleSetDefaultMfgs = () => {
    if (!shoppingPortal?.hideMfgs?.length) {
      setDefaultMfgs([]);
      return;
    }
    const data = dmsManufacturers.filter((mfg) =>
      shoppingPortal.hideMfgs.includes(String(mfg.code))
    );
    setDefaultMfgs(data);
  };

  const goToShoppingPortal = () => {
    const trimmedUrl = shopifyUrl?.replace(/^https?:\/\//, "");

    window.open("/ShoppingPortal/Parts?store=" + trimmedUrl, "_blank");
  };
  const handleSetPortalEnable = (action: boolean) => {
    dispatch(setPartsPortalEnable({ isEnabled: action }));
    enablePortalMutation({
      data: { PortalId: shoppingPortal?.id ?? "", IsEnabled: action },
    });
  };
  return (
    <>
      <PageLoader
        isLoading={addShoppingPortalMutationResult.isLoading || isLoading}
      ></PageLoader>

      <Container maxWidth={false}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
              Portal Setting
            </Typography>
            <Link
              sx={{
                display: shoppingPortal.id !== "" ? "block" : "none",
                cursor: "pointer",
              }}
              onClick={goToShoppingPortal}
            >
              View
            </Link>
          </Box>
          <Box display={shoppingPortal.id !== "" ? "block" : "none"}>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={partsPortalSetting?.isPortalEnabled}
                  onChange={(e: any) => handleSetPortalEnable(e.target.checked)}
                  name="enablePortal"
                  color="warning"
                />
              }
              label="Enable Portal"
            />
          </Box>
        </Box>
        <Box display={"flex"} alignItems={"center"} mt={1} gap={2}>
          {shoppingPortal?.id &&
          showAlert &&
          partsPortalSetting?.isPortalEnabled === false ? (
            <Alert
              severity="error"
              onClose={() => {
                setShowAlert(false);
              }}
            >
              Parts portal is disabled. Customers won't be able to access it.
            </Alert>
          ) : null}
          {storeAlert && (
            <Alert
              severity="error"
              onClose={() => {
                setStoreAlert(undefined);
              }}
            >
              {storeAlert}
            </Alert>
          )}
        </Box>
        <Card sx={{ mt: 1 }}>
          <CardContent>
            {" "}
            <Formik
              initialValues={shoppingPortal}
              enableReinitialize={true}
              validationSchema={ShoppingPortalValidationSchema}
              innerRef={formRef}
              onSubmit={(values) => {
                handleOnSubmit(values);
              }}
            >
              {({ values, handleChange, handleBlur, setFieldValue }) => (
                <>
                  <Form>
                    <Grid container spacing={3} p={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="portalName"
                          name="portalName"
                          label="Portal Name"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.portalName}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="portalName"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="email"
                          name="email"
                          label="Email"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="email"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="address"
                          name="address"
                          label="Address"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          sx={{ marginTop: "-7px" }}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="address"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <PhoneInput
                          country={"us"}
                          preferredCountries={["us", "ca"]}
                          value={values.primaryPhone}
                          onChange={(primaryPhone) =>
                            setFieldValue("primaryPhone", primaryPhone)
                          }
                          onBlur={handleBlur}
                          inputStyle={{
                            width: "100%",
                            border: "none",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                            borderRadius: 0,
                            outline: "none",
                            boxShadow: "none",
                          }}
                          containerClass="custom-phone-class"
                          specialLabel="Primary Phone"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="primaryPhone"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <PhoneInput
                          country={"us"}
                          preferredCountries={["us", "ca"]}
                          value={values.secondaryPhone}
                          onChange={(secondaryPhone) =>
                            setFieldValue("secondaryPhone", secondaryPhone)
                          }
                          onBlur={handleBlur}
                          inputStyle={{
                            width: "100%",
                            border: "none",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                            borderRadius: 0,
                            outline: "none",
                            boxShadow: "none",
                          }}
                          containerClass="custom-phone-class"
                          specialLabel="Secondary Phone"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="secondaryPhone"
                        />
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="input-fb-url"
                          name="facebookURL"
                          label="Facebook"
                          fullWidth
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.facebookURL}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <FacebookIcon
                                  sx={{ color: "rgb(56, 55, 110)" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                          variant="standard"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="facebookURL"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="input-tw-url"
                          name="twitterURL"
                          label="Twitter / X"
                          fullWidth
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.twitterURL}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <TwitterIcon
                                  sx={{ color: "rgb(56, 55, 110)" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                          variant="standard"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="twitterURL"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="input-li-url"
                          name="linkedInURL"
                          label="LinkedIn"
                          fullWidth
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.linkedInURL}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <LinkedInIcon
                                  sx={{ color: "rgb(56, 55, 110)" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                          variant="standard"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="linkedInURL"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="input-insta-url"
                          name="instagramURL"
                          label="Instagram"
                          fullWidth
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.instagramURL}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <InstagramIcon
                                  sx={{ color: "rgb(56, 55, 110)" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                          variant="standard"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="instagramURL"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          type="number"
                          id="input-insta-url"
                          name="shippingCharge"
                          label="Shipping Charge($)"
                          fullWidth
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.shippingCharge}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <LocalShippingIcon
                                  sx={{ color: "rgb(56, 55, 110)" }}
                                />
                              </InputAdornment>
                            ),
                          }}
                          variant="standard"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="shippingCharge"
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <TextField
                          id="input-insta-url"
                          name="storefrontAccessToken"
                          label="Storefront Access Token"
                          fullWidth
                          disabled={
                            shoppingPortal?.id &&
                            shoppingPortal?.storefrontAccessToken
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.storefrontAccessToken}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <KeyIcon sx={{ color: "rgb(56, 55, 110)" }} />
                              </InputAdornment>
                            ),
                          }}
                          variant="standard"
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="storefrontAccessToken"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControl variant="standard" fullWidth>
                          <InputLabel id="portalType-label">
                            Portal Type
                          </InputLabel>
                          <Select
                            name={"portalType"}
                            id="portalType"
                            value={values.portalType}
                            onChange={handleChange}
                            defaultValue={PartsPortalType.StandAlone}
                            fullWidth
                          >
                            <MenuItem value={PartsPortalType.StandAlone}>
                              Standalone
                            </MenuItem>
                            <MenuItem value={PartsPortalType.Embedded}>
                              Embedded
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Autocomplete
                          multiple
                          options={dmsManufacturers}
                          getOptionLabel={(option) => option.name}
                          value={defaultMfgs}
                          id="clear-on-escape"
                          clearOnEscape
                          onChange={(e, value) => {
                            setDefaultMfgs(value);
                            setFieldValue(
                              "hideMfgs",
                              value.map((item) => item.code)
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Hide Manufacturers"
                              variant="standard"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item sm={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={values.activeCategoryFilter}
                                onChange={(e) => {
                                  setFieldValue(
                                    "activeCategoryFilter",
                                    e.target.checked
                                  );
                                }}
                              />
                            }
                            label="Category Filter Page"
                          />
                        </FormGroup>
                      </Grid>
                      <Grid item sm={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={values.activeManufacturerFilter}
                                onChange={(e) => {
                                  setFieldValue(
                                    "activeManufacturerFilter",
                                    e.target.checked
                                  );
                                }}
                              />
                            }
                            label="Manufacturer Filter Page"
                          />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          sx={{
                            color: "rgba(0, 0, 0, 0.6)",

                            marginBottom: "-15px",
                          }}
                        >
                          <Tooltip
                            title={
                              "The invoice note will be included in the email sent to customers when their orders are created."
                            }
                          >
                            <span>
                              Invoice Note{" "}
                              <IconButton>
                                <InfoIcon sx={{ fontSize: "1rem" }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextareaAutosize
                          placeholder="Invoice Note for Customer Email"
                          aria-label="Invoive Note"
                          id={"invoiceNote"}
                          name={"invoiceNote"}
                          minRows={5}
                          style={{ width: "100%" }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.invoiceNote}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography
                          sx={{
                            color: "rgba(0, 0, 0, 0.6)",

                            marginBottom: "-15px",
                          }}
                        >
                          About
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <ReactQuill
                          id={"about"}
                          value={values.about}
                          placeholder="About"
                          theme="snow"
                          modules={{
                            clipboard: {
                              matchVisual: false,
                            },
                          }}
                          onChange={(e) => {
                            setFieldValue("about", e);
                          }}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="about"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} mt={2}>
                        <label htmlFor="portalLogo">
                          <TextField
                            type="file"
                            sx={{ display: "none" }}
                            id="portalLogo"
                            name="portalLogo"
                            label="Portal Logo"
                            fullWidth
                            disabled={savedLogo?.id}
                            autoComplete="family-name"
                            variant="standard"
                            onChange={(e: any) => {
                              setSavedLogo(null);
                              setFieldValue("portalLogo", e.target.files[0]);
                            }}
                            onBlur={handleBlur}
                          />

                          <Button
                            size="small"
                            disabled={savedLogo?.id}
                            variant="contained"
                            component="span"
                          >
                            Upload Logo
                          </Button>

                          <ErrorMessage
                            className="error-msg"
                            component={"div"}
                            name="portalLogo"
                          />
                        </label>
                        <br />
                        {values.portalLogo?.name ? (
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <img
                              style={{
                                width: "150px",
                                height: "100px",
                                marginTop: "10px",
                                borderRadius: 5,
                              }}
                              alt="preview image"
                              src={URL.createObjectURL(values.portalLogo)}
                            />
                            <IconButton
                              size="small"
                              style={{
                                position: "absolute",
                                top: 6,
                                right: -3,
                                backgroundColor: "white",
                              }}
                              onClick={() => {
                                setFieldValue("portalLogo", null);
                              }}
                            >
                              <CloseIcon
                                sx={{
                                  color: "rgb(56, 55, 110)",
                                  fontSize: "13px",
                                }}
                              />
                            </IconButton>
                          </div>
                        ) : savedLogo?.id ? (
                          ""
                        ) : (
                          <Typography>No File Selected</Typography>
                        )}
                        {savedLogo?.id ? (
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <img
                              style={{
                                width: "150px",
                                height: "100px",
                                marginTop: "10px",
                                borderRadius: 5,
                              }}
                              alt="preview image"
                              src={savedLogo?.absoluteUrl}
                            />
                            <IconButton
                              size="small"
                              style={{
                                position: "absolute",
                                top: 6,
                                right: -3,
                                backgroundColor: "white",
                              }}
                              onClick={() => {
                                setFieldValue("portalLogoName", "");
                                setFieldValue("portalLogo", null);
                                setSavedLogo(null);
                                handleDeleteImage(savedLogo.id);
                              }}
                            >
                              <CloseIcon
                                sx={{
                                  color: "rgb(56, 55, 110)",
                                  fontSize: "13px",
                                }}
                              />
                            </IconButton>
                          </div>
                        ) : (
                          ""
                        )}
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <label htmlFor="bannerImages">
                          <TextField
                            type="file"
                            sx={{ display: "none" }}
                            id="bannerImages"
                            name="bannerImages"
                            label="Banner Images"
                            fullWidth
                            autoComplete="family-name"
                            variant="standard"
                            onChange={(e: any) => {
                              if (e && e.target.files.length > 0) {
                                var file = e.target.files[0];
                                const newFiles = [...values.bannerImages, file];
                                setFieldValue("bannerImages", newFiles);
                              }
                            }}
                            onBlur={handleBlur}
                          />

                          <Button
                            variant="contained"
                            size="small"
                            component="span"
                          >
                            Upload Banner Images
                          </Button>
                          <ErrorMessage
                            className="error-msg"
                            component={"div"}
                            name="bannerImages"
                          />
                        </label>

                        <br />
                        {values.bannerImages?.length > 0 ? (
                          values.bannerImages?.map(
                            (file: any, index: number) => (
                              <div
                                key={index}
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                <img
                                  style={{
                                    width: "150px",
                                    height: "100px",
                                    marginTop: "10px",
                                    borderRadius: 5,
                                    marginLeft: 3,
                                  }}
                                  alt="preview image"
                                  src={URL.createObjectURL(file)}
                                />

                                <IconButton
                                  size="small"
                                  style={{
                                    position: "absolute",
                                    top: 6,
                                    right: -3,
                                    backgroundColor: "white",
                                  }}
                                  onClick={() => {
                                    let valuesToSplice = values.bannerImages;
                                    valuesToSplice.splice(index, 1);
                                    if (valuesToSplice.length > 0) {
                                      setFieldValue(
                                        "bannerImages",
                                        valuesToSplice
                                      );
                                    } else {
                                      setFieldValue("bannerImages", []);
                                    }
                                  }}
                                >
                                  <CloseIcon
                                    sx={{
                                      color: "rgb(56, 55, 110)",
                                      fontSize: "13px",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            )
                          )
                        ) : savedImages?.length > 0 ? (
                          ""
                        ) : (
                          <Typography>No files selected </Typography>
                        )}
                        {savedImages?.length > 0
                          ? savedImages?.map((img: any, index: number) => (
                              <div
                                key={index}
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                <img
                                  style={{
                                    width: "150px",
                                    height: "100px",
                                    marginTop: "10px",
                                    borderRadius: 5,
                                    marginLeft: 3,
                                  }}
                                  alt="preview image"
                                  src={img.absoluteUrl}
                                />

                                <IconButton
                                  size="small"
                                  style={{
                                    position: "absolute",
                                    top: 6,
                                    right: -3,
                                    backgroundColor: "white",
                                  }}
                                  onClick={() => {
                                    console.log("Id of deleted Image", img.id);
                                    setSavedImages(
                                      savedImages.filter(
                                        (item: any) => item.id !== img?.id
                                      )
                                    );
                                    handleDeleteImage(img.id);
                                  }}
                                >
                                  <CloseIcon
                                    sx={{
                                      color: "rgb(56, 55, 110)",
                                      fontSize: "13px",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            ))
                          : ""}
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="contained"
                          type="submit"
                          sx={{ alignSelf: "flex-end" }}
                          onClick={() => {}}
                          endIcon={
                            addShoppingPortalMutationResult.isLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : (
                              <></>
                            )
                          }
                          disabled={addShoppingPortalMutationResult.isLoading}
                        >
                          {shoppingPortal.id ? "Update" : "Save"}
                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                </>
              )}
            </Formik>
          </CardContent>
        </Card>
      </Container>
    </>
  );
};
